import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'

import FakeInput from '../components/FakeInput'

const CreditBalance: FC<{ FormName: string }> = ({ FormName }) => {
  const balance: number = useSelector((state) => formValueSelector(FormName)(state, 'CreditAccBalance') || 0)

  return <FakeInput>{balance.toFixed(2)}</FakeInput>
}

export default CreditBalance
